/**
 * An array of strings representing the blacklisted Quick link data keys.
 * These keys are excluded from the quick link data to prevent unwanted
 * properties from being included in the quick link creation or editing process.
 *
 * @constant
 * @type {string[]}
 * @example
 */
export const QUICK_LINK_DATA_BLACKLIST: string[] = [
  '~branch_ad_format',
  '~campaign',
  '~campaign_type',
  '~channel',
  '~creation_source',
  '~feature',
  '~id',
  '~marketing',
  '~os_type',
  '~secondary_ad_format',
  '~tags',
  '~quick_link_template_id',
  '~link_template_id',
  '~link_type',
  '~qr_customized',
  '$android_deepview',
  '$android_url',
  '$custom_event_attribution_window_days',
  '$desktop_deepview',
  '$desktop_url',
  '$identity_id',
  '$ios_deepview',
  '$ios_url',
  '$household_measurement',
  '$link_title',
  '$marketing_title',
  '$og_description',
  '$og_image_url',
  '$og_title',
  '$one_time_use',
  '+created_as_tune_link',
  '+match_guaranteed',
  '+url',
];
